import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskEditComponent } from './task-edit.component';
import { CtButtonModule, CtFormModule, CtModelModule } from '@ctsolution/ct-framework';
import {MatLegacyCardModule as MatCardModule} from "@angular/material/legacy-card";
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { TaskService } from '../task.service';
import { LeadSelectionModule } from '../lead-selection/lead-selection.module';
import { TaskCloneModule } from '../task-clone/task-clone.module';


@NgModule({
  imports: [
    CommonModule,
    CtFormModule,
    MatCardModule,
    CtButtonModule,
    FlexLayoutModule,
    MatLegacyButtonModule,
    CtModelModule,
    LeadSelectionModule,
    TaskCloneModule
  ],
  declarations: [TaskEditComponent],
  exports: [TaskEditComponent],
  providers: [TaskService]
})
export class TaskEditModule { }
